<template>
    <template v-if="!isComplete"><div class="my-5">История согласований загружается...</div></template>
    <template v-else>
        <div class="table-inner" v-for="currentRoute in routes" :key="currentRoute.id">
          <div class="form-group  d-flex flex-wrap align-items-center solid justify-content-between mt-3" v-if="currentRoute.isComplete">
            <h4
              :class="{'marker-new': checkModifiedItem(currentRoute?.id,1)}" 
              class="m-0 py-3">
              {{currentRoute.name + " (" + currentRoute.status+ " " + $momentFormat(currentRoute.dtComplete, "DD.MM.YYYY HH:mm") + ")"}}
            </h4>
          </div>      
          <table class="table-custom" v-if="currentRoute.isComplete && currentRoute.stepsDto && currentRoute.stepsDto.length > 0" >
            <colgroup>
              <col width="150px" />
              <col width="250px" />
              <col width="150px" />
              <col width="150px" />
              <col/>
              <col/>
            </colgroup>

            <thead>
              <tr><th  class="align-middle text-center">Этап</th>
                  <th  class="align-middle ">Организация</th>
                  <th  class="align-middle">Дата поступления</th>
                  <th  class="align-middle">Дата смены статуса</th>
                  <th  class="align-middle">Ответственный</th>
                  <th  class="align-middle">Статус, комментарий</th>
              </tr>
              </thead>
              <tbody >
                  <tr v-for="(step, stepIdx) in currentRoute.stepsDto" :key="step.id">
                    <td class="align-middle text-center">{{ stepIdx===0 ? 'Формирование' : (stepIdx===1 ? 'Согласование' : 'Утверждение') }}</td>
                    <td class="p-0"><div class="signer-item" v-for="signer in step.signersDto" :key="signer.id">{{signer.organizationName}}</div></td>
                    <td class="p-0"><div class="signer-item" v-for="signer in step.signersDto" :key="signer.id">{{stepIdx > 0 ? $momentFormat(currentRoute.stepsDto[stepIdx - 1].dtComplete, "DD.MM.YYYY HH:mm") : ''}}</div></td>
                    <td class="p-0"><div class="signer-item" v-for="signer in step.signersDto" :key="signer.id">{{ $momentFormat(signer.dtComplete, "DD.MM.YYYY HH:mm") }}</div></td>
                    <td class="p-0">
                      <div class="signer-item" v-for="signer in step.signersDto" :key="signer.id">
                        <div>{{signer.userText}}</div>
                      </div>
                    </td>

                    <td class="p-0"> 
                      <div class="signer-item" v-for="signer in step.signersDto" :key="signer.id">
                        <div>
                          <div :class="signer.decision ? 'text-success' : (signer.decision === false ? 'text-danger' : '')">
                            {{signerDecision(signer, stepIdx)}}</div>	                        
                          <div>{{signer.comment}}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
              </tbody>
          </table>
        </div>
    </template>
</template>

<script>
  import API from "../api/route";

  export default {
    name: "HistoryRouteComponent",
    props: {
      journalId: {
        type: Number,
        required: true,
        default: 0
      },
      needUpdate: {
        type: Number,
        required: false,
        default: 0
      },
      responseStatusOfChange: Array
    },
    data() {
      return {
        isComplete: false,
        routes: []
      };
    }, 
    watch: {
        journalId: function (/*newValue, oldValue*/) {
            this.loadRoutes()
        },
        needUpdate: function (){
            this.loadRoutes()
        }
    },     
    mounted() {
      this.loadRoutes();
    },
    methods: {
      loadRoutes() {
        if (this.journalId > 0) {
          API.history({journalId: this.journalId}).then((response) => {
            this.routes = response.data;
            this.isComplete = true;
          });
        }
        else {
          this.isComplete = true;
        }
      },
      signerDecision(signer, stepIdx) {
        var positive = 'Согласован';
        if (stepIdx === 0)
          positive = 'Создан';
        if (stepIdx === 2)
          positive = 'Утвержден';
        return signer.decision ? positive : (signer.decision === false ? 'Отказ' : 'Решение не выносилось')
      },
      checkModifiedItem(id,statusId){
        let check = false;
        let patientChangeId = statusId;
        if(this.responseStatusOfChange){
          this.responseStatusOfChange.findIndex(element => {
            if (element.itemId === id && element.patientChangeId === patientChangeId) {
              check = true;
              return check;
            }
            check = false;
            return check;
          });
          return check
        }
      }	
    }
  }
</script>


<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';
.signer-item{
	padding: 20px 16px;
	min-height: 120px;
	&:not(:last-child){
		border-bottom: 1px solid #d7d7e0
	};
	align-items: center;
  display: flex;
}
.table-custom{
	tr{
		td{
			padding: 20px 16px;
			vertical-align: top;
		}
	}
}
.table-inner{
    overflow-x: auto;
	&:not(:last-child){
		margin-bottom: 1.5rem;
	}
}

  tr.noBorder td {
    border: 0;
    width: 100%;

  }
    .form-check-input{
        position: static !important;
    }


.solid {
    background-color:#F5F5FA;//rgba(171,171,179, 0.1);
    line-height: 3rem;
    letter-spacing: 0.5px;
}    
</style>
